import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { conversationalWorkflow } from "./constants";
import type { GetConversationalWorkflowResult } from "./types";
import { isGetConversationalWorkflowResult } from "./validators";

type GetConversationalWorkflowArgs = [appGroupId: string, workflowId: string, operatorSafe: boolean];

export const getConversationalWorkflow = reactQueryFetcherAdapter<
  typeof conversationalWorkflow,
  readonly [rootKey: RootCacheKey<typeof conversationalWorkflow>, ...originalKey: GetConversationalWorkflowArgs],
  GetConversationalWorkflowArgs,
  GetConversationalWorkflowResult
>(
  conversationalWorkflow,
  (
    signal: AbortSignal,
    ...[appGroupId, workflowId, operatorSafe]: GetConversationalWorkflowArgs
  ): Promise<GetConversationalWorkflowResult> => {
    return fetch(
      `/${appGroupId}/conversational/workflow/${workflowId}`,
      "GET",
      { operator_safe: operatorSafe },
      { signal }
    );
  },
  isGetConversationalWorkflowResult
);
